import Home from "@/views/Home.vue";
import Login from "@/views/Login/Login";
import Loginas from "@/views/Login/Loginas";
import Contact from "@/views/Login/Contact";
import Support from "@/views/Login/Support";
import Guide from "@/views/Login/Guide";
import Services from "@/views/Login/Services";
import AudienceEntry from "@/views/Login/AudienceEntry";
import page404 from "@/views/Login/404";
import Verification from "@/views/Login/Verification";
import CompletionInformation from "@/views/Login/CompletionInformation";
import LoginWithPass from "@/views/Login/LoginWithPass";
import ForgotPassword from "@/views/Login/ForgotPassword";
import Register from "@/views/Login/Register";
import Gap from "@/views/MyGap/Gap";
import Users from "@/views/MyGap/Users";
import Profile from "@/views/MyGap/Profile";
import Meets from "@/views/MyGap/Meets";
import MyMeets from "@/views/MyGap/MyMeets/MyMeets";
import PresenceAbsence from "@/views/MyGap/Reports/PresenceAbsence";
import Accounting from "@/views/MyGap/Reports/Accounting";
import MeetGroups from "@/views/MyGap/MyMeets/MeetGroups";
import InvitedMeetings from "@/views/MyGap/MyMeets/InvitedMeetings";
import Organization from "@/views/MyGap/MyMeets/Organization";
import MeetGroupEdit from "@/views/MyGap/MyMeets/MeetGroupEdit";
import Records from "@/views/MyGap/MyMeets/Records";
import Finance from "@/views/MyGap/Finance";
import FinanceList from "@/views/MyGap/FinanceList";
import Plans from "@/views/MyGap/Plans";
import Packages from "@/views/MyGap/Packages";
import Reports from "@/views/MyGap/Reports";
import AddNewSission1 from "@/views/MyGap/AddNewSission1";
import AddNewSission2 from "@/views/MyGap/AddNewSission2";
import AddNewSission3 from "@/views/MyGap/AddNewSission3";
import Invoice from "@/views/MyGap/Invoice";
import Callback from "@/views/MyGap/Callback";
import SessionDetails from "@/views/MyGap/SessionDetails";
import MyUsers from "@/views/MyGap/MyUsers/MyUsers";
import UserGroups from "@/views/MyGap/MyUsers/UserGroups";
import UserGroupEdit from "@/views/MyGap/MyUsers/UserGroupEdit";
import AddNewUser from "@/views/MyGap/MyUsers/AddNewUser";

export const routes = [
  {
    path: "/",
    name: "home",
    component: Login,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/loginas/:id",
    name: "loginas",
    component: Loginas,
  },
  {
    path: "/services",
    name: "services",
    component: Services,
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact,
  },
  {
    path: "/guide",
    name: "guide",
    component: Guide,
  },
  {
    path: "/support",
    name: "support",
    component: Support,
  },

  {
    path: "/verification",
    name: "verification",
    component: Verification,
  },
  {
    path: "/v/:id",
    name: "goToMeet",
    component: AudienceEntry,
  },
  {
    path: "/ipg_callback",
    name: "callback",
    component: Callback,
  },
  {
    path: "/404",
    name: "404",
    component: page404,
  },
  {
    path: "/completionInformation",
    name: "completionInformation",
    component: CompletionInformation,
  },
  {
    path: "/login-with-pass",
    name: "loginWithPass",
    component: LoginWithPass,
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/my-gap",
    name: "mygap",
    component: Gap,
    children: [
      {
        path: "/my-gap/users",
        name: "users",
        component: Users,
        children: [
          {
            path: "/my-gap/users/my-users",
            name: "myUsers",
            component: MyUsers,
          },
          {
            path: "/my-gap/users/user-groups",
            name: "userGroups",
            component: UserGroups,
          },
          {
            path: "/my-gap/users/user-group-edit",
            name: "userGroupEdit",
            component: UserGroupEdit,
          },
          {
            path: "/my-gap/users/add-new-user",
            name: "addNewUser",
            component: AddNewUser,
          },
        ],
      },
      { path: "/my-gap/my-profile", name: "myProfile", component: Profile },
      {
        path: "/my-gap/meets",
        name: "meets",
        component: Meets,
        children: [
          {
            path: "/my-gap/meets/my-meets",
            name: "myMeets",
            component: MyMeets,
          },
          {
            path: "/my-gap/meets/meet-groups",
            name: "meetGroups",
            component: MeetGroups,
          },
          {
            path: "/my-gap/meets/invited-meetings",
            name: "invitedMeetings",
            component: InvitedMeetings,
          },
          {
            path: "/my-gap/meets/organization",
            name: "organization",
            component: Organization,
          },
          {
            path: "/my-gap/meets/meet-groups",
            name: "meetGroups",
            component: MeetGroups,
          },
          {
            path: "/my-gap/meets/meet-group-edit",
            name: "meetGroupEdit",
            component: MeetGroupEdit,
          },
          {
            path: "/my-gap/meets/records",
            name: "records",
            component: Records,
          },
        ],
      },
      {
        path: "/my-gap/myMeets/add-new-session-step1",
        name: "addNewSission1",
        component: AddNewSission1,
      },
      {
        path: "/my-gap/myMeets/add-new-session-step2",
        name: "addNewSission2",
        component: AddNewSission2,
      },
      {
        path: "/my-gap/myMeets/add-new-session-step3",
        name: "addNewSission3",
        component: AddNewSission3,
      },
      { path: "/my-gap/myMeets/invoice", name: "invoice", component: Invoice },
      {
        path: "/my-gap/myMeets/session-details",
        name: "sessionDetails",
        component: SessionDetails,
      },
      { path: "/my-gap/finance", name: "finance", component: Finance },
      {
        path: "/my-gap/finance-list",
        name: "financeList",
        component: FinanceList,
      },
      {
        path: "/my-gap/plans",
        name: "plans",
        component: Plans,
      },
      {
        path: "/my-gap/plans/package",
        name: "plansPackage",
        component: Plans,
      },
      {
        path: "/my-gap/plans/invoice",
        name: "plansInvoice",
        component: Plans,
      },
      {
        path: "/my-gap/packages",
        name: "packages",
        component: Packages,
      },
      {
        path: "/my-gap/reports",
        name: "reports",
        component: Reports,
        children: [
          {
            path: "/my-gap/reports/presence-absence",
            name: "presenceAbsence",
            component: PresenceAbsence,
          },
          {
            path: "/my-gap/reports/accounting",
            name: "accounting",
            component: Accounting,
          },
        ],
      },
    ],
  },
];
